module.exports = __webpack_public_path__ + "c5cf8ad4946e7dc72a743267e56f1929.svg";